import React, { useState } from "react";
import { Popconfirm } from "antd";
import { LogoutOutlined, UserOutlined, LockOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  XDownOutlined,
  XDropdown,
  XHeaderTopRight,
} from "./HeaderStyle";
import InitialsAvatar from "../InitialsAvatar/InitialsAvatar";
import ProfileEditModal from "../ProfileModals/ProfileEditModal";
import ChangePasswordModal from "../ProfileModals/ChangePasswordModal";
import {
  ProfileDropdownMenu,
  ProfileDropdownItem,
  ProfileDropdownDivider,
} from "../Sidebar/SidebarStyle";
import { PopconfirmGlobalStyles } from "../../pages/Surveys/Create/QuestionPreview.style";
import { getUserData } from "../../utils/permissions";
import { logoutApi } from "../../store/actions/loginAction";

const dropdownResetStyle = {
  position: "static",
  bottom: "auto",
  left: "auto",
  right: "auto",
  marginBottom: 0,
  minWidth: 200,
};

const HeaderTop = ({ responsive = false }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userData = getUserData();
  const userName = userData?.name || "User";
  const [isProfileEditOpen, setIsProfileEditOpen] = useState(false);
  const [isChangePasswordOpen, setIsChangePasswordOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleLogout = () => {
    dispatch(logoutApi());
    navigate("/login");
  };

  const renderDropdown = () => (
    <ProfileDropdownMenu isOpen style={dropdownResetStyle}>
      <ProfileDropdownItem
        onClick={() => {
          setIsProfileEditOpen(true);
          setIsDropdownOpen(false);
        }}
      >
        <UserOutlined />
        Edit Profile
      </ProfileDropdownItem>
      <ProfileDropdownItem
        onClick={() => {
          setIsChangePasswordOpen(true);
          setIsDropdownOpen(false);
        }}
      >
        <LockOutlined />
        Change Password
      </ProfileDropdownItem>
      <ProfileDropdownDivider />
      <Popconfirm
        title="Confirm Logout"
        description="Are you sure you want to logout?"
        okText="Yes"
        cancelText="No"
        onConfirm={handleLogout}
        placement="bottomRight"
      >
        <ProfileDropdownItem className="danger">
          <LogoutOutlined />
          Log Out
        </ProfileDropdownItem>
      </Popconfirm>
    </ProfileDropdownMenu>
  );

  return (
    <XHeaderTopRight $responsive={responsive}>
      <PopconfirmGlobalStyles />
      <XDropdown
        dropdownRender={renderDropdown}
        open={isDropdownOpen}
        onOpenChange={setIsDropdownOpen}
        placement="bottomRight"
        trigger={["click"]}
      >
        <div
          className="header-profile-trigger"
          style={{ cursor: "pointer" }}
        >
          <InitialsAvatar name={userName} size={responsive ? 36 : 40} />
          <span className="hideMob">{userName}</span>
          <XDownOutlined $responsive={responsive} />
        </div>
      </XDropdown>

      <ProfileEditModal
        open={isProfileEditOpen}
        onClose={() => setIsProfileEditOpen(false)}
      />
      <ChangePasswordModal
        open={isChangePasswordOpen}
        onClose={() => setIsChangePasswordOpen(false)}
      />
    </XHeaderTopRight>
  );
};

export default HeaderTop;
